module.exports={render:function (){with(this) {
  return _h('i', {
    staticClass: "ion-icon",
    class: [setName, setColor, isParentItem ? 'item-icon' : ''],
    attrs: {
      "role": "img"
    }
  })
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad7b9748!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icon/src/icon.vue
// module id = 166
// module chunks = 0